import {Pipe, PipeTransform} from '@angular/core';
import {DomainType} from '../../../generate/TopLevelDomainVO';

@Pipe({
  name: 'metadataHelper'
})
export class MetadataHelperPipe implements PipeTransform {

  transform(value: DomainType, ...args: unknown[]): unknown {
    switch (value) {
      case "GENERIC":
        return 'Generic';
      case 'COUNTRY_CODE':
        return "Country Code";
      case 'ROOT':
        return "Root";
      case 'SPECIAL':
        return "Special";
      default:
        return value;
    }
  }

}
